module.exports = __webpack_public_path__ + "static/img/place_3.04c4b8fa.png";